import { Col, Row } from 'react-bootstrap';
import React from 'react';
import { styled } from 'styletron-react';
import { TechemTheme } from '@techem/techem-theme';

const GreyLine = styled('div', {
  height: '1px',
  backgroundColor: TechemTheme.colors.backgroundSecondary
});

const HorizontalLine = () => {
  return (
    <Row className="justify-content-center">
      <Col xs={12}>
        <GreyLine className="w-100" />
      </Col>
    </Row>
  );
};

export default HorizontalLine;
